/**
 * PaymentStatusPill — пилюля статуса платежа (точка + текст, мягкий фон).
 * Централизованная палитра статусов (успех/в обработке/неудача/возврат). `size`:
 * md — таблица десктопа, sm — карточки мобилки.
 */

import type {PaymentStatus} from '@services/payments';

const META: Record<PaymentStatus, {label: string; text: string; bg: string}> = {
  success: {label: 'Успешно', text: '#1B7A54', bg: '#E6F4EC'},
  pending: {label: 'В обработке', text: '#2C5CDB', bg: '#EAF0FD'},
  failed: {label: 'Неудачно', text: '#C6362C', bg: '#FBE9E7'},
  refund: {label: 'Возврат', text: '#B07908', bg: '#FBF3E4'},
};

type PaymentStatusPillProps = {
  status: PaymentStatus;
  size?: 'md' | 'sm';
};

export const PaymentStatusPill = ({status, size = 'md'}: PaymentStatusPillProps) => {
  const m = META[status];
  const sm = size === 'sm';
  return (
    <span
      className={`inline-flex items-center rounded-full font-semibold ${
        sm
          ? 'mt-1 gap-1.5 px-[7px] py-0.5 text-[10.5px]'
          : 'gap-1.5 px-[9px] py-[3px] text-[12.5px]'
      }`}
      style={{background: m.bg, color: m.text}}
    >
      <span
        className="rounded-full"
        style={{width: sm ? 5 : 6, height: sm ? 5 : 6, background: m.text}}
      />
      {m.label}
    </span>
  );
};
